module.exports = __webpack_public_path__ + "img/leftarrow.297a80e2.svg";